import { finalizeBasket } from 'containers/OrderDetails/basketSlice'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import Gate from 'containers/entrance/core/Gate'
import BackBtn from 'components/buttons/BackBtn'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import InfoMagbox from './popups/InfoMagbox'
import Warehouse from 'components/Warehouse'
import MagNumber from 'components/MagNumber'
import { useDispatch } from 'react-redux'
import cardImg from 'assets/img/card.png'
import { useState } from 'react'
import './style.scss'

const DetailsSlide = ({ locks, back, showHeader = true, close }) => {
  const [currentLockIndex, setCurrentLockIndex] = useState(0)
  const [currentPageIndex, setCurrentPageIndex] = useState(0)
  const [pinVisible, setPinVisible] = useState(true);

  const { popup, pathname } = usePopupState()
  const currentLock = locks[currentLockIndex]
  const currentPage = currentLock.pages[currentPageIndex]

  const { push } = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation('newWarehouse')
  const handleNext = () => {
    if (currentPageIndex < currentLock.pages.length - 1) {
      setCurrentPageIndex(currentPageIndex + 1)
    } else if (currentLockIndex < locks.length - 1) {
      setCurrentPageIndex(0)
      setCurrentLockIndex(currentLockIndex + 1)
    } else if (close) {
      close()
    } else {
      dispatch(finalizeBasket())
      push(`/warehouses/${currentLock.warehouseId}`)
    }
  }

  const handleBack = () => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1)
    } else if (currentLockIndex > 0) {
      setCurrentLockIndex(currentLockIndex - 1)
      setCurrentPageIndex(locks[currentLockIndex - 1].pages.length - 1)
    } else {
      back()
    }
  }

  const renderSectionContent = (section) => {
    switch (section.type) {
      case 'text': return (
        <p>{section.content}</p>
      )

      case 'phone': return (
        <p className='phone'>{section.content}</p>
      )

      case 'infoModal': return (
        <button onClick={() => push(pathname, LOCATION_STATES.popup(section.content))}>{section.title}</button>
      )

      case 'pin': return (
        section.content.split('').map((char, index) => (
          <div key={index} className='rec'>{pinVisible ? char : '*'}</div>
        ))
      )

      case 'prefixed_pin': return (
        <>
          {section.pinPrefix && section.pinPrefix.split('').map((char, index) => (
            <div key={index} className='rec --primary'>{pinVisible ? char : '*'}</div>
          ))}
          {section.pin.split('').map((char, index) => (
            <div key={index} className='rec'>{pinVisible ? char : '*'}</div>
          ))}
        </>
      )

      default: return <p>{section.content}</p>
    }
  }

  return (
    <>
      {popup === 'magbox' && <InfoMagbox />}
      {popup === 'totem' && <InfoMagbox />}
      <div className='detailsSlide'>
        {showHeader && <div className='detailsSlide__head'>
          <MagNumber number={currentLock.warehouseNumber} />
          <div className='slide__address'>{currentLock.placeAdress}</div>
        </div>}

        <div className='detailsSlide__body'>
          <div className='detailsSlide__body__img'>
            {(() => {
              switch (currentPage.img) {
                case 'gate': return (
                  <Gate />
                )

                case 'parking': return (
                  <div className='slide__warehouses'>
                    <div className='warehouse --center'>
                      <Warehouse rentableType='parking' />
                    </div>
                  </div>
                )

                case 'card': return (
                  <img
                    src={cardImg}
                    alt='card' />
                )

                case 'custom': return (
                  <img
                    src={currentPage.photoUrl}
                    alt='storage'
                  />
                )

                default: return (
                  <div className='slide__warehouses'>
                    <div className='warehouse --left'>
                      <Warehouse warehouseAnimation={currentPage.warehouseAnimation} />
                    </div>
                    <div className='warehouse --center'>
                      <Warehouse warehouseAnimation={currentPage.warehouseAnimation} />
                    </div>
                    <div className='warehouse --right'>
                      <Warehouse warehouseAnimation={currentPage.warehouseAnimation} />
                    </div>
                  </div>
                )
              }
            })()}

          </div>

          {currentPage.sections.map((section, index) => (
            <div key={index} className='section'>
              <div className='section__title'>
                <h2>{section.title}</h2>
                {section.type.includes('pin') && (
                  <i
                    className={`icon icon--eye${pinVisible ? '-close' : ''}`}
                    onClick={() => setPinVisible(!pinVisible)}
                  />
                )}
              </div>
              <div className='section__content'>
                {renderSectionContent(section)}
              </div>
            </div>
          ))}
        </div>

        <div className='detailsSlide__footer'>
          <BackBtn action={handleBack} />
          <ArrowBtn action={handleNext} enlarged showArrow text={t('next')} />
        </div>
      </div>
    </>)
}

export default DetailsSlide